module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), _c('el-carousel', {
    staticClass: "article",
    style: ('background-color:' + _vm.config.bgcolor),
    attrs: {
      "height": "30px",
      "direction": _vm.config.direction,
      "indicator-position": "none",
      "arrow": "never"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('div', {
      staticClass: "article-item",
      style: ('color:' + _vm.config.fontcolor)
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n      ")])])
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e2b87d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e2b87d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/marquees.vue
// module id = 2649
// module chunks = 0